import { GenericModelApi } from "./GenericModelApi";
import { ApiSchema } from "./ApiClient";
import { RoleFormData } from "@/formTypes/RoleDataType";

export type RoleDataType = Partial<ApiSchema["Role"]["type"] & RoleFormData>;
class Api extends GenericModelApi<"Role", RoleDataType> {
    /** Roles de una suscripcion por su tenantId (owner) como { id: name }, para uso admin. */
    async optionsListByTenantId(tenantId: string): Promise<Record<string, string>> {
        const { items = [] } = await this.fetchAllByOwnerId(tenantId);
        return items.filter(i => !!i.id).reduce((acc, role) => ({
            ...acc,
            [`${role.id}`]: `${role.name || ""}`,
        }), {} as Record<string, string>);
    }
}
export const RoleApi = new Api("Role", "name", "ASC");